<template lang="pug">
  .component-edit-reporting-type
    .row
      .column
        label Name
          input(type="text", v-model="body.name")
      .column
        label Description
          input(type="text", v-model="body.description")
    .row
      .column
        .switch.small
          label Position required
          input#position-required.switch-input(type='checkbox', v-model="body.position_required")
          label.switch-paddle(for='position-required')
            span.show-for-sr Position required
            span.switch-active(aria-hidden='true') Yes
            span.switch-inactive(aria-hidden='true')
      .column
        .switch.small
          label Attachment required
          input#attachment_required.switch-input(type='checkbox', v-model="body.attachment_required")
          label.switch-paddle(for='attachment_required')
            span.show-for-sr Attachment required
            span.switch-active(aria-hidden='true') Yes
            span.switch-inactive(aria-hidden='true') No
    .row
      .columns.actions
        button.button.small(@click="save") Save
</template>

<script>
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'

  export default {
    name: 'EditReportingType',
    data() {
      return {
        body: {
          name: null,
          description: null,
          position_required: false,
          description_required: false,
        }
      }
    },
    mounted() {
      if (this.reportingType) {
        this.body = Object.assign({}, this.reportingType)
      }
    },
    methods: {
      save() {
        if (this.reportingType) {
          KeplerBackofficeSdk.reportingTypes.select(this.reportingType.id).edit(this.body, () => {
            MaggieHelper.notification('Edited', 'Reporting type edited successfully')
            this.$emit('reportingTypeEdited')
          })

          return
        }

        KeplerBackofficeSdk.reportingTypes.make(this.body, () => {
          MaggieHelper.notification('Created', 'Reporting type created successfully')
          window.location.reload()
        })
      }
    },
    props: ['reportingType']
  }
</script>

<style lang="sass">
  .component-edit-reporting-type
    .actions
      margin-top: 50px
      text-align: right

</style>



// WEBPACK FOOTER //
// EditReportingType.vue?3d6939df